import './index.scss';

import { FlexWrapObserver } from '../../atoms/flex-wrap-observer';

class IconList1 {
    constructor(root) {
        this.root = root;

        // Opt-in only: editor checkbox adds iconlist1--vertical-mobile.
        if (!this.root.classList.contains('iconlist1--vertical-mobile')) {
            return;
        }

        this.wrapObserver = new FlexWrapObserver(this.root, {
            listSelector: '.iconlist1__list',
            itemSelector: ':scope > .iconlist1__item',
            stackedClass: 'iconlist1--stacked',
        });
    }
}

document.querySelectorAll('.iconlist1.iconlist1--vertical-mobile').forEach((node) => {
    new IconList1(node);
});
